import { Typography } from "@material-ui/core";
import { IconSwitch } from "./IconSwitch";
import { useTranslation } from "react-i18next";

/**
 * @author IKlapouch
 * 07/02/2021
 */

export const IconLabelSwitch = ({ name, isHeader, labelName, headerAlign, size, customLabel, variant, color }) => {
    const { t } = useTranslation()

    const divStyle = {
        display: isHeader ? 'flex' : null,
        justifyContent: isHeader
            ? headerAlign ? headerAlign : 'center'
            : null
    }

    const typographyStyle = {
        display: "flex",
        alignItems: "center",
        color: isHeader ? "#29438d" : null,
    };

    const labelStyle = {
        fontWeight: isHeader ? "bold" : null,
        fontSize: isHeader ? "0.875rem" : null,
        marginLeft: "0.5em",
    };

    return (
        <>
            <div style={divStyle}>
                <Typography variant={variant} style={typographyStyle}>
                    <IconSwitch name={name} isHeader={isHeader} size={size} color={color} />
                    <div style={labelStyle}>{customLabel ? customLabel : labelName ? t(labelName) : t(name)}</div>
                </Typography>
            </div>
        </>
    );
};
